// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-container[data-v-34709a26]{position:relative}.svg-image[data-v-34709a26]{width:100px;height:100px}@media(max-width:700px){.svg-card-container[data-v-34709a26]{flex-direction:column}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
